<template>
    <div class="tx-ktgdealersearch module-filters-selected" v-if="divisions.length + models.length + services.length + model.length + layouts.length">
        <div class="filters-selected__filter"
             @click="divisions = divisions.filter(selected => selected !== filter.id)"
             v-for="(filter, index) in vehicleTypes.filter(object => divisions.includes(object.id))"
             :key="index">
            <span>{{ filter.description }}</span>
        </div>
        <div class="filters-selected__filter"
             @click="models = models.filter(selected => selected !== filter.ids.toString())"
             v-for="(filter, index) in availableModels.filter(object => models.includes(object.ids.toString()))"
             :key="index">
            <span>{{ filter.name }}</span>
        </div>
        <div class="filters-selected__filter"
             @click="services = services.filter(selected => selected !== filter.id)"
             v-for="(filter, index) in [...serviceStations, ...rentalStations, ...campingPlaces].filter(object => services.includes(object.id))"
             :key="index">
            <span>{{ filter.description }}</span>
        </div>
        <div class="filters-selected__filter"
             @click="model = '';layouts = []"
             v-if="model">
            <span>{{ model }}</span>
        </div>
        <div class="filters-selected__filter"
             @click="layouts = layouts.filter(selected => selected !== filter.id)"
             v-for="(filter, index) in availableLayouts.filter(object => layouts.includes(object.id))"
             :key="index">
            <span>{{ filter.description }}</span>
        </div>
        <div class="filters-selected__clear"
             @click="clearAll()"
             v-if="(divisions.length + models.length + services.length + (model ? 1 : 0) + (layout && length ? 1 : 0)) >= 2">
            <span>{{ $t('filterBar.filters.clearAll') }}</span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FilterSelected',
  computed: {
    availableModels () {
      let models = []
      this.$store.state.filter.available.models.forEach(brand => {
        brand.fieldset.forEach(division => {
          models = [...models, ...division.options]
        })
      })
      return models
    },
    ...mapState({
      vehicleTypes: state => state.filter.available.vehicleTypes,
      serviceStations: state => state.filter.available.serviceStations,
      rentalStations: state => state.filter.available.rentalStations,
      campingPlaces: state => state.filter.available.campingPlaces,
      availableLayouts: state => state.filter.available.layouts
    }),
    divisions: {
      get () {
        return this.$store.state.filter.divisions
      },
      set (value) {
        this.$store.commit('filter/setDivisions', value)
        this.filter()
      }
    },
    models: {
      get () {
        return this.$store.state.filter.models
      },
      set (value) {
        this.$store.commit('filter/setModels', value)
        this.filter()
      }
    },
    services: {
      get () {
        return this.$store.state.filter.services
      },
      set (value) {
        this.$store.commit('filter/setServices', value)
        this.filter()
      }
    },
    model: {
      get () {
        return this.$store.state.filter.model
      },
      set (value) {
        this.$store.commit('filter/setModel', value)
        this.filter()
      }
    },
    layouts: {
      get () {
        return this.$store.state.filter.layouts
      },
      set (value) {
        this.$store.commit('filter/setLayouts', value)
        this.filter()
      }
    }
  },
  methods: {
    ...mapActions([
      'filter'
    ]),
    clearAll () {
      this.divisions = []
      this.models = []
      this.services = []
      this.model = ''
      this.layouts = []
    }
  }
}
</script>
